import { Container } from './Containers';
import Header from './Header';
import Plan from './Plan';

export default function Skeleton() {
	const getContainer = (key, highlight = false) => (
		<Container key={key} highlight={highlight} loading={true}>
			<Header />
			<div className="prc-content">
				<Plan loading={true} highlight={highlight ? ' ' : ''} />
			</div>
		</Container>
	);

	const containers = [false, true, false].map((container, i) => getContainer(i, container));
	return containers;
}
